module.exports = __webpack_public_path__ + "img/crown.ce6ed656.png";